import { combineReducers } from '@reduxjs/toolkit';
import personal from './userSettingsSlice';

const reducer = combineReducers({
	personal
});

export default reducer;
